import {
    DeliveryDetails,
    MenuItem,
    PriceInCurrency
} from "../menu/models";
import {ChosenMenuItemModifierSet, ChosenMenuItemModifierSetExtended} from "../../types/types";


export enum PaymentProviderType {
    cloudpayments = 'CloudPaymentsCheckout',
    offline = 'Offline',
    toBankCard = 'BankCardRequisites',
    companyInvoice =  'CompanyBankAccountRequisites',
    sbpTochka = 'SBPTochka'
}

export interface CloudPaymentsDetails{
    type: PaymentProviderType.cloudpayments,
    isPaid: boolean;
    receiptLink?: string
}
// Отметки о возвратах остаются в кабинете: гостю приезжают ссылка на QR и чек.
export interface SbpTochkaDetails{
    type: PaymentProviderType.sbpTochka,
    isPaid: boolean;
    receiptLink: string | null,
    qrCodeLink: string,
}

export interface OfflinePaymentsDetails{
    type: PaymentProviderType.offline,
    isPaid: boolean;
    changeFromAmount: PriceInCurrency | null;
}

export interface ToBankCardPaymentsDetails{
    type: PaymentProviderType.toBankCard,
    isPaid: boolean;
    requisites: string;
}

// Реквизиты получателя гость выбирает при оформлении, в ответе они не возвращаются.
export interface ICompanyBankAccountRequisites {
    type: PaymentProviderType.companyInvoice,
    isPaid: boolean;
    pdfActUrl: string;
    pdfInvoiceUrl: string;
}

export enum RecipientType{
    russianOOOCard = "RecipientRussianOOOCard",
    russianIPCard = "RecipientRussianIPCard"
}

export interface RecipientRussianOOOCard{
    type: RecipientType.russianOOOCard
    contractId: string;
    inn: string;
    legalAddress: string;
    shortTitle: string;
    kpp: string;

}

export interface RecipientRussianIPCard {
    type: RecipientType.russianIPCard,
    contractId: string;
    inn: string;
    legalAddress: string;
    shortTitle: string;
    ogrnip: string;
}

export type RecipientCompanyCard = RecipientRussianOOOCard | RecipientRussianIPCard;


export type OrderPaymentDetails = CloudPaymentsDetails | SbpTochkaDetails | OfflinePaymentsDetails | ToBankCardPaymentsDetails | ICompanyBankAccountRequisites;

export interface CloudPaymentsCheckout {
    type: PaymentProviderType.cloudpayments
}

export interface SBPTochka {
    type: PaymentProviderType.sbpTochka
}

export interface Offline {
    type: PaymentProviderType.offline
    changeFromAmount: PriceInCurrency | null;
    method: string | null;
}

export interface BankCardRequisites {
    type: PaymentProviderType.toBankCard
    requisites: string;
}


export interface CompanyBankAccountRequisites {
    recipientCompanyCard: RecipientCompanyCard;
    type: PaymentProviderType.companyInvoice
}

interface OrderItem {
    chosenMenuItemModifierSets: ChosenMenuItemModifierSetExtended[];
    comment: string | null;
    menuItem: MenuItem;
    menuItemsCount: number;
    price: PriceInCurrency;
}


export type NewOrderPaymentDetails = CloudPaymentsCheckout | SBPTochka | Offline | BankCardRequisites | CompanyBankAccountRequisites


/*
* Заказ в том виде, в каком его отдаёт бэк гостю: без контактов заказавшего (адрес и телефон
* приезжают замаскированными), без истории статусов и без снимков категорий и наборов
* модификаторов — состав позиции самодостаточен.
* */
export interface Order {
    id: number;
    organizationId: number;
    organizationBranchId: number;
    menuId: number;
    items: OrderItem[];
    totalPrice: PriceInCurrency;
    status: OrderStatus;
    deliveryDetails: DeliveryDetails;
    createdAt: Date;
    paymentDetails: OrderPaymentDetails | null;
    clientLocaleId: string;
    loyaltyProgram: LoyaltyProgram | null;
    externalOrderNumber?: string | null;
    externalId?: string | null;
    // Проставляется корзиной при создании заказа и живёт только в локальной истории заказов.
    clientId?: number | null;
}
export interface LoyaltyProgram {
    phoneNumber: string;
    typeOperation: OperationType;
}
export type OperationType = "Withdraw" | "Deposit";

export enum OrderStatus {
    preorder = 'Preorder',
    new = 'New',
    accepted = 'Accepted',
    paid = 'Paid',
    canceled = 'Canceled',
    ready = 'Ready',
    givenOut = 'GivenOut',
    readyToPickUp = 'ReadyToPickUp',
    givenOutToDelivery = 'GivenOutToDelivery',
    finished = 'Finished',
    canceledByKitchen = 'CanceledByKitchen',
    canceledWithRefund = 'CanceledWithRefund',
    sentToKitchen = 'SentToKitchen',
    acceptedByKitchen = 'AcceptedByKitchen'
}

export enum CouponType {
    percentage = 'Percentage',
    fixedAmount = 'FixedAmount'

}

export interface PercentageCouponData {
    type: CouponType.percentage;
    code: string;
    endDate: Date;
    startDate: Date;
    discountPercent: number;
}
export interface FixedAmountCouponData {
    type: CouponType.fixedAmount;
    code: string;
    discountAmount: AmountInCurrency;
    endDate: Date;
    startDate: Date;
}

export interface AmountInCurrency {
    amount: number;
    currencyId: string;
}


export type CouponCalculationVariants = PercentageCouponData | FixedAmountCouponData;


export interface Coupon {
    data: CouponCalculationVariants;
    id: number;
    menuId: number;
    organizationBranchId: number;
    organizationId: number;
}


export interface NewOrderItem {
    chosenMenuItemModifierSets: ChosenMenuItemModifierSet[];
    comment: string | null;
    menuItemId: number;
    menuItemsCount: number;
}

export interface NewOrder {
    deliveryDetails: DeliveryDetails;
    paymentDetails: NewOrderPaymentDetails,
    items: NewOrderItem[];
    menuId: number;
    clientSessionId: string | null,
    orderSessionId: string | null,
    clientLocaleId: string,
    comment: string,
    couponCode: string | null,
    loyaltyProgram: LoyaltyProgram | null
}


/*
* Подсказка адреса от DaData в том виде, в каком её отдаёт бэк: без обёртки data и без полей,
* которые корзина не показывает (индекс, регион, квартира, точность геокодирования).
* */
export interface AddressSuggestion {
    city: string | null;
    settlement: string | null;
    settlement_type: string | null;
    street: string | null;
    street_type: string | null;
    street_type_full: string | null;
    house: string | null;
    house_type: string | null;
    house_type_full: string | null;
    block: string | null;
    block_type: string | null;
    block_type_full: string | null;
    geo_lat: string | null;
    geo_lon: string | null;
}
